module.exports = __webpack_public_path__ + "static/img/no-data.81bed948.png";